//引用axios
import axios from "axios";
export default {
  namespaced: true, // 开启命名空间，调用时需指定模块名
  state: {
    // 存储企业官网后台系统左侧导航栏路由列表
    companyRoutersList:
      JSON.parse(localStorage.getItem("companyRoutersList")) || [],
    // 存储企业官网后台系统左侧组件库路由列表
    sliderNavbarList:
      JSON.parse(localStorage.getItem("sliderNavbarList")) || [],
    // 存储页面组件
    pageComponets: localStorage.getItem("pageComponets") || [],
    // 底部导航栏页面数据（转换后的格式）
    tabbarPagesData: [],
    templateData: {
      global: { title: "园区小程序" },
      pages: [],
      tabBar: {},
    },
    currentKey: "home", // 当前正在装修的页面: "首页", 默认首页
    // 模块设计模块的底部导航栏静态数据: 0,
    tabbarKeyData: ["home", "notification", "activity", "user", "find"],
    // 访问顺序栈，只存 pag
    historyStack: ["page_home"],
    // 以下变量用于文章列表组件库
    ArticlePool: [], // 后台拉取的全量文章池
    selectedArticleIds: [], // 当前页面已选中的文章 id 数组
    currentComponent: {
      moduleName: "",
    }, // 模块装修页面需要用到的 当前选中的组件（横向标签组件）

    // 存储当前正在操作的横向标签组件数据
    tagList: [],
  },
  mutations: {
    // 设置企业路由列表
    setCompanyRoutersList(state, routersList) {
      state.companyRoutersList = routersList;
      //分别存储到缓存里
      localStorage.setItem("companyRoutersList", JSON.stringify(routersList));
    },
    // 设置企业官网后台系统左侧组件库路由列表
    setSliderNavbarList(state, routersList) {
      state.sliderNavbarList = routersList;
      console.log("vux中的setSliderNavbarList存储上了", routersList);
      localStorage.setItem("sliderNavbarList", JSON.stringify(routersList));
    },
    // 存储页面组件
    setPageComponets(state, pages) {
      state.templateData.pages = pages;
      // console.log(
      //   "setPageComponets方法中接收到的----------------------------",
      //   pages,
      //   state.templateData
      // );
      // localStorage.setItem("pageComponets", JSON.stringify(components));
    },
    // 存储页面组件
    SET_PUSH_PAGE(state, pages) {
      for (const p of pages) {
        const exist = state.templateData.pages.find(
          (i) => i.pageId === p.pageId,
        );
        if (!exist) state.templateData.pages.push(p);
        else exist.components.push(p.components); // 已存在直接放到对应页面的compponents里
      }
      console.log("vuex中PUSH_PAGE方法获取", state.templateData.pages);
    },
    // 存储底部导航栏页面数据（转换后的格式）
    SET_PUSH_TAB(state, tab) {
      state.templateData.tabBar = tab;
    },
    // 过滤所有页面组件，根据当前页面ID匹配并存储到对应页面pages
    SET_PUSH_COMPONENT(state, { pageId, page }) {
      // console.log(
      //   "打印过滤所有页面vux",
      //   state.templateData.pages,
      //   pageId,
      //   page
      // );
      //过滤state里的pages， 如果传入的pageId和当前过滤state里的pages的pageId相等， 则用page替换
      state.templateData.pages = state.templateData.pages.map((item) => {
        if (item.pageId === pageId) {
          return page;
        }
        return item;
      });
    },
    // 存储底部导航栏的每一项的key值
    // SET_TABBAR_KEY_DATA(state, data) {
    //   state.tabbarKeyData = data;
    // },
    // 删除模版页面
    DEL_PAGE(state, pageId) {
      const idx = state.templateData.pages.findIndex(
        (p) => p.pageId === pageId,
      );
      if (idx > -1) state.templateData.pages.splice(idx, 1);
    },
    // 存储全局golobal
    SET_GLOBAL(state, data) {
      state.templateData.global = data;
    },
    // 压栈（进入新页时调用）
    PUSH_HISTORY(state, pageId) {
      // 重复访问同一页不压栈
      if (state.historyStack.at(-1) !== pageId) {
        state.historyStack.push(pageId);
      }
    },
    // 弹栈（点返回时调用）
    POP_HISTORY(state) {
      if (state.historyStack.length > 1) {
        state.historyStack.pop();
      }
    },
    SET_POOL(state, list) {
      state.ArticlePool = list;
    },
    SET_SELECTED(state, ids) {
      state.selectedArticleIds = ids;
    },
    ADD_SELECTED(state, article) {
      if (!state.selectedArticleIds.includes(article.id)) {
        state.selectedArticleIds.unshift(article.id);
        state.ArticlePool.unshift(article); // 池里也加一条，保证左侧立刻出现
      }
      localStorage.setItem(
        "selectedArticleIds",
        JSON.stringify(state.selectedArticleIds),
      );
      localStorage.setItem("ArticlePool", JSON.stringify(state.ArticlePool));
    },
    REMOVE_SELECTED(state, id) {
      const idx = state.selectedArticleIds.indexOf(id);
      if (idx > -1) state.selectedArticleIds.splice(idx, 1);
    },
    // 更新并缓存projectData
    // updateProjectData(state, newData) {
    //   state.projectData = { ...state.projectData, ...newData };
    //   localStorage.setItem("projectData", JSON.stringify(state.projectData));
    // },
    // // 缓存projectData（用于修改后自动保存）
    // cacheProjectData(state) {
    //   localStorage.setItem("projectData", JSON.stringify(state.projectData));
    // },
    // // 修改用户信息
    // setUserInfo(state, info) {
    //   state.userId = info.userId;
    //   state.username = info.username;
    // },
    // setParentInfo(state, data) {
    //   console.log("VUX里setParentInfo方法执行", data);
    //   state.parentContainerInfo = deepClone(data || {});
    //   // console.log(state.parentContainerInfo)
    // },
    // 设置当前选中的组件（横向标签组件）
    SET_CURRENT_COMPONENT(state, component) {
      state.currentComponent = component;
    },
    // 清除当前选中的组件（横向标签组件）
    CLEAR_CURRENT_COMPONENT(state) {
      state.currentComponent = {};
    },
    // 存储横向标签组件数据
    SET_TAG_LIST(state, list) {
      state.tagList = list;
    },
  },
  actions: {
    // 存储页面组件
    setPageComponets({ commit }, components) {
      commit("setPageComponets", components);
    },
    // ======================================
    // 新增：封装动态添加页面的核心 Action（公共方法）
    // ======================================
    /**
     * 动态添加页面到 Vuex templateData.pages
     * @param {Object} context - Vuex 上下文（包含 commit、state 等）
     * @param {Object} payload - 入参对象
     * @param {Object} payload.currentItem - 当前选中项（必须包含 id、text 属性）
     * @param {Object} payload.item - 待修改的项（必须包含 http 属性）
     * @param {Array} payload.imageList - 图片列表（用于修改对应项的 internalLink）
     * @param {Number} payload.index - 图片列表的当前索引
     * @param {Object} [payload.vueInstance] - Vue 实例（用于 $set 响应式更新，可选）
     * @returns {Object} - 操作结果（成功/失败、新页面数据等）
     */
    addDynamicPage({ commit, state }, payload) {
      try {
        // 1. 解构入参并校验必要参数
        const { pageId, pageName, pageSetup, isBack, components, path } =
          payload;
        console.log(
          "vuex的addDynamicPage方法获取",
          payload,
          pageId,
          pageName,
          pageSetup,
          isBack,
          components,
        );

        // if (!pageId || !pageName || !pageSetup || !isBack || !components) {
        //   console.error(
        //     "【addDynamicPage】缺少必要参数：pageId、pageName、pageSetup、isBack、components 不能为空"
        //   );
        //   return { success: false, msg: "缺少必要参数" };
        // }
        const newPage = {
          pageId: pageId,
          isBack: isBack, // 是否支持返回（固定值，如需动态配置可从 payload 传入）
          pageName: pageName,
          path: path,
          pageSetup: pageSetup, // 直接从 Vuex state 读取，无需外部传入
          components: components, // 空页面（如需动态配置可从 payload 传入）
        };

        // 3. 提交 mutation，添加页面到 Vuex
        commit("SET_PUSH_PAGE", [newPage]);
        console.log("走到这里了", newPage);

        // 5. 返回成功结果
        return {
          success: true,
          newPage,
        };
      } catch (error) {
        console.error("【addDynamicPage】页面添加失败：", error.message);
        // 6. 返回失败结果
        return {
          success: false,
          msg: error.message,
          error: error,
        };
      }
    },
    // 删除模版页面
    delPage({ commit }, pageId) {
      try {
        // 1. 解构入参并校验必要参数
        if (!pageId) {
          console.error("【delPage】缺少必要参数：pageId 不能为空");
          return { success: false, msg: "缺少必要参数" };
        }

        commit("DEL_PAGE", pageId);
        return {
          success: true,
          pageId: pageId,
          msg: "删除成功",
        };
      } catch (error) {
        console.error("【addDynamicPage】页面添加失败：", error.message);
        // 6. 返回失败结果
        return {
          success: false,
          msg: error.message,
          error: error,
        };
      }
    },
    // 获取需要删除的节点索引值
    // reqDeleteNodeElement({ getters, commit }, uuid) {
    //   const { activeElementIndex } = getters;
    //   if (!uuid) return "";
    //   const indexData = activeElementIndex(uuid);
    //   commit("deleteNodeElement", indexData);
    // },
    // 获取企业路由列表
    // async getCompanyRoutersList({ commit }) {
    //   try {
    //     const data = await this._vm.$api.auth.getCompanyRoutersAPI({ menuId : 2079});
    //     const res = await this._vm.$api.auth.getCompanyRoutersAPI();
    //     console.log("datadatadatadatadatadatadatadatadata", data.data.data,res.data.data[0].children);
    //     if (res.status === 200) {
    //       // 存储企业路由列表
    //       commit("setCompanyRoutersList", res.data.data[0].children || []);
    //       // 存储企业官网后台系统左侧组件库路由列表
    //       commit("setSliderNavbarList", data.data.data);

    //       return res.data.data[0].children;
    //     }
    //     return [];
    //   } catch (error) {
    //     console.error("获取企业路由列表失败", error);
    //     return [];
    //   }
    // },
    async getArticlePool({ commit }) {
      const { data } = await axios.get(
        "http://192.168.3.194:5050/api/v1/article/json/list",
      );
      commit("SET_POOL", data);
    },
    // 新建文章 -> 先调接口 -> 再 commit
    async createArticle({ commit }, payload) {
      try {
        const result = await this._vm.$api.admin.article.createArticleAPI(
          payload,
        );
        console.log("vuex打印新建文章接口结果", result);
        result.data.data.id = result.data.data._id;
        commit("ADD_SELECTED", result.data.data); // data = {id,text,description,...}
        return result;
      } catch (error) {
        console.error("获取企业路由列表失败", error);
        return [];
      }
    },
  },
  getters: {
    // 拿上一页 id（不弹页面栈，只做预览）
    prevPageId: (state) => state.historyStack.at(-2) || "",
    // 判断是否有底部导航栏 只要包含首页就有底部导航栏
    // hasPageHome: (state) => {
    //   return state.templateData.pages.some(
    //     (item) => item.pageId === "page_home"
    //   );
    // },
  },
};
